export default {
  Title   : 'Βαθμολογήστε την εφαρμογή μας!',
  Subtitle: 'Εάν σας αρέσει να χρησιμοποιείτε το Marketplace, αφιερώστε λίγο χρόνο για να αξιολογήσετε την εμπειρία σας με την εφαρμογή μας. Βοηθάει πραγματικά!',
  Button  : 'Rate Now',
  Comments: 'Σχόλιο αξιολόγησης',
  Reviews : 'Κριτικές',
  Success : 'Ευχαριστούμε που αφιερώσατε λίγο χρόνο για να αξιολογήσετε την εφαρμογή μας!'
}
